import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faAngleDown, faAngleRight, faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import { NgxSpinnerService } from 'ngx-spinner';
import { MachineInfoService } from 'src/api/generated';
import { MachineInfoMainService } from 'src/app/shared/services/machine-info.service';
import { MachineOwnerService } from 'src/app/shared/services/owner.service';
import { TrashService } from 'src/app/shared/services/trash.service';
import { LoadingService } from 'src/app/shared/services/loading.service';

@Component({
  selector: 'app-machine-info-trash',
  templateUrl: './machine-info-trash.component.html',
  styleUrl: './machine-info-trash.component.scss'
})
export class MachineInfoTrashComponent {
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;

  faTrashRestore = faTrashRestore;
  isSmallScreen: boolean = false;
  isShowed: boolean[] = [];

  constructor(
    private _tSvc: TrashService,
    private _oSvc: MachineOwnerService,
    private _spinner: NgxSpinnerService,
    private _router: Router,
    private _miSvc: MachineInfoMainService,
    private readonly _machineInfoSvc: MachineInfoService,
    private readonly _breakpointObserver: BreakpointObserver,
    public readonly loadingService: LoadingService,
  ) { }

  ngOnInit(): void {
    this._breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  public get TSvc(): TrashService {
    return this._tSvc;
  }

  public get OSvc(): MachineOwnerService {
    return this._oSvc;
  }

  public async restore(machineName: string): Promise<void> {
    this.loadingService.startLoading();

    this._machineInfoSvc.unDeleteAllDataMachineInfo(machineName)
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.loadingService.stopLoading();
            this._miSvc.dataSource.reload();
            this._router.navigate(['/machines']);
          }, 2500);
        },
        error: (err) => {
          this.loadingService.stopLoading();
          // Handle error
        }
      });
  }

  getOwnerName(ownerId: string): string {
    const owner = this.OSvc.AllOwners.find(o => o.Id === ownerId);
    return owner ? owner.Name ?? "" : '-';
  }

  show(rowIndex: number): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }
}
